export default "__VITE_ASSET__Ds6_$Dsu__"